export class InvalidAuthPasswordError extends Error {
	static readonly NAME = 'InvalidAuthPasswordError';

	constructor(password: string) {
		super(`Auth password is invalid ${password}`);

		this.name = InvalidAuthPasswordError.NAME;
	}
}
